/**
 * @generated SignedSource<<d11879328306e88cc587de519498dd5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountEditScreen_AccountFragment$data = {
  readonly extension: {
    readonly users?: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        };
      } | null> | null;
      readonly " $fragmentSpreads": FragmentRefs<"usersInAccountTable_UserInAccountConnectionFragment">;
    };
  } | null;
  readonly groupAssociations: ReadonlyArray<{
    readonly group: {
      readonly id: string;
      readonly name: string;
    } | null;
  }>;
  readonly id: string;
  readonly isDeleted: boolean;
  readonly name: string;
  readonly registeredAt: string;
  readonly " $fragmentSpreads": FragmentRefs<"editAccountGroupsButton_AccountFragment" | "editLeadStrategyForm_AccountFragment">;
  readonly " $fragmentType": "accountEditScreen_AccountFragment";
};
export type accountEditScreen_AccountFragment$key = {
  readonly " $data"?: accountEditScreen_AccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountEditScreen_AccountFragment">;
};

import AccountEditScreen_Refetch_graphql from './AccountEditScreen_Refetch.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "extension",
  "users"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": AccountEditScreen_Refetch_graphql,
      "identifierField": "id"
    }
  },
  "name": "accountEditScreen_AccountFragment",
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registeredAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountGroupAssociation",
      "kind": "LinkedField",
      "name": "groupAssociations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountGroup",
          "kind": "LinkedField",
          "name": "group",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "accountExtensionKind",
          "value": "Tka"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "users",
              "args": null,
              "concreteType": "UserInAccountConnection",
              "kind": "LinkedField",
              "name": "__AccountEditScreen_users_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserInAccountEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "UserInAccount",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "usersInAccountTable_UserInAccountConnectionFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TkaAccountExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(accountExtensionKind:\"Tka\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "editAccountGroupsButton_AccountFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "editLeadStrategyForm_AccountFragment"
    }
  ],
  "type": "Account",
  "abstractKey": null
};
})();

(node as any).hash = "f08a0f5007f7c963bb5cca3f6a2857b6";

export default node;
